define(['exports', 'react', 'lodash', '../../i18n', './styles/CandidateReportsView.css'], function (exports, _react, _lodash, _i18n) {
	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _react2 = _interopRequireDefault(_react);

	var _lodash2 = _interopRequireDefault(_lodash);

	var _i18n2 = _interopRequireDefault(_i18n);

	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : {
			default: obj
		};
	}

	function _classCallCheck(instance, Constructor) {
		if (!(instance instanceof Constructor)) {
			throw new TypeError("Cannot call a class as a function");
		}
	}

	var _createClass = function () {
		function defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];
				descriptor.enumerable = descriptor.enumerable || false;
				descriptor.configurable = true;
				if ("value" in descriptor) descriptor.writable = true;
				Object.defineProperty(target, descriptor.key, descriptor);
			}
		}

		return function (Constructor, protoProps, staticProps) {
			if (protoProps) defineProperties(Constructor.prototype, protoProps);
			if (staticProps) defineProperties(Constructor, staticProps);
			return Constructor;
		};
	}();

	function _possibleConstructorReturn(self, call) {
		if (!self) {
			throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		}

		return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}

	function _inherits(subClass, superClass) {
		if (typeof superClass !== "function" && superClass !== null) {
			throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
		}

		subClass.prototype = Object.create(superClass && superClass.prototype, {
			constructor: {
				value: subClass,
				enumerable: false,
				writable: true,
				configurable: true
			}
		});
		if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}

	var HeaderBar = function (_Component) {
		_inherits(HeaderBar, _Component);

		function HeaderBar() {
			_classCallCheck(this, HeaderBar);

			return _possibleConstructorReturn(this, (HeaderBar.__proto__ || Object.getPrototypeOf(HeaderBar)).apply(this, arguments));
		}

		_createClass(HeaderBar, [{
			key: 'renderTitle',
			value: function renderTitle() {
				return _react2.default.createElement(
					'div',
					{ className: 'name-primary nunito-font' },
					_i18n2.default.t('dk-ui-lib.reports.detailed_assessment_report')
				);
			}
		}, {
			key: 'renderName',
			value: function renderName(name) {
				return _react2.default.createElement(
					'div',
					{ className: 'mr3 name-primary nunito-font' },
					name.toUpperCase()
				);
			}
		}, {
			key: 'renderCandidateLevel',
			value: function renderCandidateLevel(categoryName) {
				return _react2.default.createElement(
					'div',
					{ className: 'flex mt1 ' },
					_react2.default.createElement(
						'div',
						null,
						_i18n2.default.t('dk-ui-lib.reports.candidate_level')
					),
					_react2.default.createElement(
						'div',
						{ className: 'mx1' },
						'-'
					),
					_react2.default.createElement(
						'div',
						{ className: 'value-primary' },
						categoryName ? categoryName.toUpperCase() : 'FRESHER'
					)
				);
			}
		}, {
			key: 'renderCandidateSkillName',
			value: function renderCandidateSkillName(skill, assessmentName) {
				var skillName = void 0;
				if (_lodash2.default.isString(skill) && skill.length) {
					skillName = skill.toUpperCase();
				} else if (_lodash2.default.isString(assessmentName) && assessmentName.includes('-')) {
					skillName = assessmentName.split('-')[0];
				}
				return _react2.default.createElement(
					'div',
					{ className: 'flex' },
					_react2.default.createElement(
						'div',
						null,
						_i18n2.default.t('dk-ui-lib.reports.skill')
					),
					_react2.default.createElement(
						'div',
						{ className: 'mx1' },
						'-'
					),
					_react2.default.createElement(
						'div',
						{ className: 'value-primary' },
						skillName || 'N/A'
					)
				);
			}
		}, {
			key: 'renderCandidateSkillLevel',
			value: function renderCandidateSkillLevel(skillLevel, assessmentName) {
				var _skillLevel = void 0;

				if (_lodash2.default.isString(skillLevel) || _lodash2.default.isNumber(skillLevel)) {
					_skillLevel = skillLevel;
				} else if (_lodash2.default.isString(assessmentName) && assessmentName.includes('-')) {
					_skillLevel = assessmentName.split('-')[1];
				}
				return _react2.default.createElement(
					'div',
					{ className: 'ml3 flex items-center' },
					_react2.default.createElement(
						'div',
						null,
						_i18n2.default.t('dk-ui-lib.reports.skill_level')
					),
					_react2.default.createElement(
						'div',
						{ className: 'mx1' },
						'-'
					),
					_react2.default.createElement(
						'div',
						{ className: 'value-primary' },
						_skillLevel || 'N/A'
					)
				);
			}
		}, {
			key: 'renderCandidateNameAndLevel',
			value: function renderCandidateNameAndLevel() {
				var _props = this.props,
				    candidateName = _props.candidateName,
				    _props$categoryName = _props.categoryName,
				    categoryName = _props$categoryName === undefined ? '' : _props$categoryName;

				return _react2.default.createElement(
					'div',
					null,
					this.renderName(candidateName),
					this.renderCandidateLevel(categoryName)
				);
			}
		}, {
			key: 'render',
			value: function render() {
				var _props2 = this.props,
				    assessment = _props2.assessment,
				    isDetailedReportsView = _props2.isDetailedReportsView;

				return _react2.default.createElement(
					'div',
					{ className: 'mx4 p3 border rounded flex justify-between items-center' },
					isDetailedReportsView ? this.renderTitle() : this.renderCandidateNameAndLevel(),
					_react2.default.createElement('div', { className: 'mx3 border-right vertical-border-color self-stretch' }),
					this.renderCandidateSkillName(assessment.skill, assessment.name),
					this.renderCandidateSkillLevel(assessment.skillLevel, assessment.name)
				);
			}
		}]);

		return HeaderBar;
	}(_react.Component);

	exports.default = HeaderBar;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dk-ui-lib/lib/candidate-reports/HeaderBar.js
// module id = 1192
// module chunks = 0